import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function LearnerLogin() {
  const navigate = useNavigate();
  const [userId, setUserId] = useState('');
  const [inputError, setInputError] = useState('');

  const handleUserIdChange = (e) => {
    setUserId(e.target.value);
    setInputError('');
  };

  const handleSubmit = () => {
    if (!userId || isNaN(userId) || userId === '0') {
      setInputError('有効なユーザーIDを入力してください（0以外の数値）');
      return;
    }
    navigate('/learner', { state: { userId: parseInt(userId) } });
  };

  const handleBack = () => {
    navigate('/');
  };

  return (
    <main className="container-center">
      <section className="card">
        <header className="card-header">
          <h1 className="text-2xl font-semibold">学習者ログイン</h1>
          <p className="text-subtitle mt-2">あなたのユーザーIDを入力してください</p>
        </header>
        <div className="form-group">
          <input
            type="number"
            value={userId}
            onChange={handleUserIdChange}
            placeholder="ユーザーIDを入力"
            className="form-input form-input--green"
            min="1"
          />
          {inputError && <p className="text-error">{inputError}</p>}
          <button onClick={handleSubmit} className="btn btn--primary w-full">
            ログイン
          </button>
          <button onClick={handleBack} className="btn btn--gray w-full">
            戻る
          </button>
        </div>
      </section>
    </main>
  );
}

export default LearnerLogin;
